import { Select, SelectProps, Typography } from 'antd'
import { useAtom } from 'jotai'
import React from 'react'

import { UserAvatar } from '@/components'
import { departmentsMapAtom } from '@/modules/department'
import { User, userInfoAtom, usersAtom } from '@/modules/user'

export const UsersSearch: React.FC<
  SelectProps<any> & { excludeUsers?: { email: string }[]; includeEmails?: { email: string }[] }
> = React.forwardRef(({ excludeUsers = [], includeEmails, ...props }, ref) => {
  const [viewer] = useAtom(userInfoAtom)
  const [users] = useAtom(usersAtom)
  const [departmentsMap] = useAtom(departmentsMapAtom)

  const options = [viewer! as User]
    .concat(users.filter((u) => u.email !== viewer!.email))
    .filter((u) => !includeEmails || includeEmails.some((includeUser) => includeUser.email === u.email))
    .filter((u) => !excludeUsers.some((excludeUser) => excludeUser.email === u.email))
    .map((u) => (
      <Select.Option key={u.email} value={u.email} user={u} name={u.name}>
        <div className='flex'>
          <UserAvatar className='mr-8px' size='small' email={u.email} />
          <div className='text-xs leading-tight'>
            <div>{u.name}</div>
            <Typography.Text type='secondary'>
              {u.departmentIds
                .map((id) => departmentsMap![id]?.name)
                .filter(Boolean)
                .join(',')}
            </Typography.Text>
          </div>
        </div>
      </Select.Option>
    ))

  return (
    <Select
      ref={ref as any}
      showSearch
      allowClear
      showArrow={false}
      optionLabelProp='name'
      filterOption={(s, o) => o && (o.user.email.split('@')[0].includes(s) || o.user.name.includes(s))}
      {...props}
    >
      {options}
    </Select>
  )
})
